import { isOpenIdConnectEnabled } from '@shared/environment';

import { getSearchParams } from './OidcService';

const HANDOVER = 'handover/';
const HANDOVER_SUCCESS = 'handover/success/';
const HANDOVER_FAILED = 'handover/failed/';
const HANDOVER_CANCELLED = 'handover/cancelled/';

const getHandoverState = (): string => getSearchParams().get('state')?.split('||')[0] ?? '';

const getUrlFromHandoverState = (state: string): string =>
    decodeURIComponent(state)
        .replace(HANDOVER_SUCCESS, '')
        .replace(HANDOVER_FAILED, '')
        .replace(HANDOVER_CANCELLED, '')
        .replace(HANDOVER, '');

export const isHandover = (): boolean => getHandoverState().startsWith(HANDOVER);

export const isHandoverWithOidc = (): boolean => isOpenIdConnectEnabled() && isHandover();

export const handleHandover = (): void => {
    const state = getHandoverState();
    const lang = getSearchParams().get('lang');
    const { pathname } = window.location;

    if (lang) {
        window.location.href = `${pathname}?lang=${lang}#${getUrlFromHandoverState(state)}`;
        return;
    }
    window.location.href = `${pathname}#${getUrlFromHandoverState(state)}`;
};
